import * as Sentry from '@sentry/nextjs';

const isSentryEnabled = process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true';

export const sendExceptionToSentry = (exception, message) => {
  if (isSentryEnabled) {
    captureMessage(message);
    captureException(exception);
  }
};

export const captureMessage = (message) => {
  if (isSentryEnabled) {
    Sentry.captureMessage(message);
  }
};

export const captureException = (exception) => {
  if (isSentryEnabled) {
    Sentry.captureException(exception);
  }
};
